import { showNotification } from '@mantine/notifications';
import { trackEvent } from '@repo/common/analytics';
import { Button } from '@repo/foundations';
import { useNavigate } from 'react-router';
import type { IReport } from '../../../../api';
import {
	queryClient,
	reportsQueryKeyFactory,
	useAuthUser,
	useCreateReport,
} from '../../../../api';

export interface ISelectReportTemplateMenuProps {
	reportId?: string;
	populateReportWithTemplate?: (template: string) => Promise<void>;
}

function SelectReportTemplateMenu({
	reportId,
	populateReportWithTemplate,
}: ISelectReportTemplateMenuProps) {
	/* Create an untitled report when reportId is undefined or populate the reportId with the template */
	const navigate = useNavigate();
	const { user, workspace } = useAuthUser();

	const { mutateAsync: addReport } = useCreateReport({
		options: {
			onSuccess: () => {
				queryClient.invalidateQueries({
					queryKey: reportsQueryKeyFactory.allLists(),
				});
				trackEvent('analytics/report/create', {}, user, workspace);
				showNotification({
					title: 'Report created',
					message: 'Report was successfully created',
					color: 'green',
				});
			},
		},
	});

	const handleAddReport = async (
		name: string,
		type: IReport['type'],
		template?: string
	) => {
		/* Create an untitled report when reportId is undefined or populate the reportId with the template */
		if (reportId && populateReportWithTemplate && template) {
			await populateReportWithTemplate(template);
		} else {
			const report = await addReport({
				data: {
					name,
					type,
					template,
				},
			});
			navigate(`/analytics/${report.id}`);
		}
	};

	return (
		<Button
			variant="primary"
			onClick={() => handleAddReport('Untitled', 'analytics')}
		>
			Add report
		</Button>
	);
}

export default SelectReportTemplateMenu;
